import { createContext } from 'react'
import { DcContextType } from '@/types/IDc'
export const DcContext = createContext<DcContextType | undefined>(undefined)
